import { combineReducers } from "redux";
import { ActionType } from "typesafe-actions";

import { marketsActions } from "./actions";
import {
  MARKETS_FAILURE,
  MARKETS_REQUEST,
  MARKETS_SUCCESS,
} from "../../constants/markets";

export interface Market {
  code: string;
}
export type MarketsBySport = { [sport: string]: string[] };

export type MarketsState = {
  requested: boolean;
  data: { markets: Market[]; markets_by_sport: MarketsBySport | {} };
  isLoading: boolean;
  error: string | null;
};

export type MarketsActions = ActionType<typeof marketsActions>;

export const marketsReducer = combineReducers<MarketsState, MarketsActions>({
  requested: (state = false, action) => {
    switch (action.type) {
      case MARKETS_REQUEST:
        return true;
      default:
        return state;
    }
  },
  data: (state = { markets: [], markets_by_sport: {} }, action) => {
    switch (action.type) {
      case MARKETS_SUCCESS:
        return action.payload;
      default:
        return state;
    }
  },
  isLoading: (state = false, action) => {
    switch (action.type) {
      case MARKETS_REQUEST:
        return true;
      default:
        return false;
    }
  },
  error: (state = null, action) => {
    switch (action.type) {
      case MARKETS_FAILURE:
        return action.payload.message || action.payload.detail;
      default:
        return null;
    }
  },
});
